// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"80d3125c","455":"8950157b"}[chunkId] + ".chunk.js";
};